import React from "react";
import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import logo from "../../../assets/Images/PickaaGoLogo.png";
import { SingleInputField } from "../../../components";
import { PsignUpData } from "../../../assets/lib/plogin";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { CircularLoader } from "../../../components/widgets/CircularLoader";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  contentWrapper: {
    position: "relative",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    flexDirection: "column",
  },
  logo: {
    width: "160px",
  },
  formCard: {
    backgroundColor: "rgba(255, 255, 255)",
    backdropFilter: "blur(10px)",
    borderRadius: "12px",
    padding: "40px 30px",
    maxWidth: "400px",
    width: "100%",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    marginTop: "-190px",
  },
  heading: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "5px",
    marginLeft:"0px",
    color: "#880E4F",
    fontFamily: "Inter",

  },
  subheading: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "25px",
    marginLeft:"0px",
    fontWeight: 500,
    fontFamily: "Inter",

  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  button: {
    backgroundColor: "#880E4F",
    color: "#fff",
    width: "40%",
    padding: "10px",
    fontWeight: 600,
    borderRadius: "8px",
    marginLeft: "120px",
  },
  footer: {
    fontSize: "14px",
    marginTop: "20px",
    textAlign: "center",
    color: "#888",
  },
  loginLink: {
    color: "#000",
    fontWeight: 600,
    cursor: "pointer",
    marginLeft: "5px",
  },
  errorText: {
    color: "red",
    textAlign: "center",
    marginBottom: "10px",
  },
  transparentInput: {
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
      border: '1px solid rgba(255, 255, 255, 0.4)',
      color: '#000',
    },
    '& input': {
      color: '#000',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.4)',
    },
  },
}));

const Layout = (props) => {
  const {
    submitLoading,
    forgotpassCodeState,
    errorFields,
    getForgotAlpinInput,
    handleSubmitForgotAlpin,
    handleOtpSendClick,
    otp,
    isInvalidOtp,
    phoneNoNot10Digit,
    passCodeNot4Digit,
    notExistingUser,
  } = props;

  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.wrapper}>
      {submitLoading && <CircularLoader isPoistionAbsolute zIndex={3} />}

      <div style={{ width: "100vw", padding: "10px" }}>
        <img src={logo} alt="PickaaGo Logo" className={classes.logo} />
      </div>

      <div className={classes.contentWrapper}>
        <div className={classes.formCard}>
          <div className={classes.heading}>
            <strong>Reset your passcode securely</strong>
          </div>
          <div className={classes.subheading}>Let’s get you a new passcode</div>

          {phoneNoNot10Digit && <div className={classes.errorText}>Phone number must be 10 digits.</div>}
          {notExistingUser && <div className={classes.errorText}>Phone number is not registered.</div>}
          {passCodeNot4Digit && <div className={classes.errorText}>PIN must be 4 digits.</div>}
          {isInvalidOtp && (
            <div className={classes.errorText}>
              Invalid OTP!
              <span
                onClick={handleOtpSendClick}
                style={{ cursor: "pointer", color: "black", marginLeft: "5px" }}
              >
                Resend
              </span>
            </div>
          )}

          <div className={classes.inputContainer}>
            <SingleInputField
              content={PsignUpData.phoneNumber}
              value={forgotpassCodeState.phoneNumber}
              getInputData={getForgotAlpinInput}
              errorFields={errorFields}
              isEditable={!otp}
              className={classes.transparentInput}
            />
            <SingleInputField
              content={PsignUpData.passCode}
              value={forgotpassCodeState.passCode}
              getInputData={getForgotAlpinInput}
              errorFields={errorFields}
              isEditable={!otp}
              className={classes.transparentInput}
            />
            {otp && (
              <SingleInputField
                content={PsignUpData.otp}
                value={forgotpassCodeState.otp}
                getInputData={getForgotAlpinInput}
                errorFields={errorFields}
                className={classes.transparentInput}
              />
            )}
          </div>

          <Button
             variant="contained"
             style={{
               backgroundColor: "#880E4F",
               color: "#fff",
               width: "40%",
               padding: "10px",
               fontWeight: 600,
               borderRadius: "8px",
               marginLeft:"120px"
             }}
            className={classes.button}
            onClick={otp ? handleSubmitForgotAlpin : handleOtpSendClick}
          >
            {otp ? "Submit" : "Send OTP"}
          </Button>

          <div className={classes.footer}>
            Remembered it?
            <span className={classes.loginLink} onClick={() => navigate(routes.PUSER_LOGIN)}>
              Login
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
